/**
 * @generated SignedSource<<1a06474461f6a0ffa8148e742d85b27d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveCreditCardFailed_charge$data = {
  readonly brCode: string | null | undefined;
  readonly company: {
    readonly logo: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly nameFriendly: string | null | undefined;
    readonly projectType: string | null | undefined;
    readonly taxID: {
      readonly taxID: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly identifier: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkAdditionalInfo_charge" | "PaymentLinkComment_charge" | "PaymentLinkPaymentTerm_charge" | "PaymentLinkTransactionDetails_charge">;
  readonly " $fragmentType": "PaymentActiveCreditCardFailed_charge";
};
export type PaymentActiveCreditCardFailed_charge$key = {
  readonly " $data"?: PaymentActiveCreditCardFailed_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveCreditCardFailed_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveCreditCardFailed_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameFriendly",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "File",
          "kind": "LinkedField",
          "name": "logo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "fitIn",
                  "value": true
                }
              ],
              "kind": "ScalarField",
              "name": "url",
              "storageKey": "url(fitIn:true)"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TaxID",
          "kind": "LinkedField",
          "name": "taxID",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "taxID",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkComment_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkPaymentTerm_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkAdditionalInfo_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkTransactionDetails_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "bba33add00d72e3567f1b3a31502ff8e";

export default node;
